export default "__VITE_ASSET__DEdYFRJg__"